(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["spx-bundle-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('dialog-component[data-spx-video-dialog]');

    roots.forEach((root) => {
      const trigger = root.querySelector('button.spx-video-dialog__trigger');
      const dialog = root.querySelector('dialog.spx-video-dialog__dialog');
      const previewVideo = root.querySelector('video.spx-video-dialog__preview-video');
      const modalVideo = root.querySelector('video.spx-video-dialog__video');

      if (!trigger || !dialog || !modalVideo) return;

      const playModalVideo = async () => {
        try {
          modalVideo.muted = false;
          await modalVideo.play();
        } catch (e) {}
      };

      const stopModalVideo = () => {
        try {
          modalVideo.pause();
          modalVideo.currentTime = 0;
        } catch (e) {}
      };

      trigger.addEventListener('click', () => {
        try {
          if (previewVideo) previewVideo.pause();
        } catch (e) {}

        stopModalVideo();
        playModalVideo();
      });

      root.addEventListener('dialog:close', () => {
        stopModalVideo();
        try {
          if (previewVideo) previewVideo.play();
        } catch (e) {}
      });

      dialog.addEventListener('close', () => {
        stopModalVideo();
        try {
          if (previewVideo) previewVideo.play();
        } catch (e) {}
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spx-custom-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    const SCROLL_LOCK_CLASS = 'spx-custom-dialog-active';

    const getScrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth;

    const captureSwiperStates = (scope) => {
      const root = scope || document;

      return Array.from(root.querySelectorAll('spx-slider'))
        .map((slider) => {
          const swiper = slider.swiperInstance;
          if (!swiper) return null;

          return {
            slider,
            activeIndex: swiper.activeIndex,
          };
        })
        .filter(Boolean);
    };

    const restoreSwiperStates = (states) => {
      states.forEach(({ slider, activeIndex }) => {
        const swiper = slider.swiperInstance;
        if (!swiper) return;

        swiper.slideTo(activeIndex, 0, false);
      });
    };

    const lockViewport = () => {
      const scrollbarWidth = getScrollbarWidth();
      document.documentElement.style.setProperty('--spx-dialog-scrollbar-compensation', `${scrollbarWidth}px`);
      document.documentElement.classList.add(SCROLL_LOCK_CLASS);
    };

    const unlockViewport = () => {
      document.documentElement.classList.remove(SCROLL_LOCK_CLASS);
      document.documentElement.style.removeProperty('--spx-dialog-scrollbar-compensation');
    };

    const finalizeDialogClose = (states) => {
      if (states?.length) {
        restoreSwiperStates(states);
        requestAnimationFrame(() => {
          restoreSwiperStates(states);
        });
      }

      unlockViewport();
    };

    const setupDialogComponent = (component) => {
      if (component.dataset.spxCustomDialogBound === 'true') return;
      component.dataset.spxCustomDialogBound = 'true';

      component.addEventListener('dialog:close', () => {
        finalizeDialogClose(component.__spxSavedSwiperStates || []);
        component.__spxSavedSwiperStates = null;
      });
    };

    const bindTriggers = () => {
      document
        .querySelectorAll('[data-spx-custom-dialog-trigger]:not([data-spx-custom-dialog-trigger-bound])')
        .forEach((trigger) => {
          trigger.dataset.spxCustomDialogTriggerBound = 'true';

          trigger.addEventListener('click', (event) => {
            event.preventDefault();

            const dialogId = trigger.getAttribute('data-spx-custom-dialog-trigger');
            if (!dialogId) return;

            const component = document.querySelector(
              `dialog-component.spx-custom-dialog[data-dialog-id="${dialogId}"]`,
            );

            if (component) {
              setupDialogComponent(component);
              component.__spxSavedSwiperStates = captureSwiperStates(
                component.closest('.shopify-section, .spx-section'),
              );
              lockViewport();

              if (typeof component.showDialog === 'function') {
                component.showDialog();
                return;
              }
            }

            const dialog = document.getElementById(dialogId);
            if (dialog && typeof dialog.showModal === 'function') {
              const savedStates = captureSwiperStates(dialog.closest('.shopify-section, .spx-section'));
              lockViewport();
              dialog.showModal();
              dialog.addEventListener(
                'close',
                () => {
                  finalizeDialogClose(savedStates);
                },
                { once: true },
              );
            }
          });
        });

      document.querySelectorAll('dialog-component.spx-custom-dialog').forEach(setupDialogComponent);
    };

    if (!window.__spxCustomDialogInit) {
      window.__spxCustomDialogInit = true;
      document.addEventListener('shopify:section:load', bindTriggers);
    }

    bindTriggers();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spx-video-dialog-nobg"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('dialog-component[data-spx-video-dialog]');

    roots.forEach((root) => {
      const trigger = root.querySelector('button.spx-video-dialog__trigger');
      const dialog = root.querySelector('dialog.spx-video-dialog__dialog');
      const previewVideo = root.querySelector('video.spx-video-dialog__preview-video');
      const modalVideo = root.querySelector('video.spx-video-dialog__video');

      if (!trigger || !dialog || !modalVideo) return;

      const playModalVideo = async () => {
        try {
          modalVideo.muted = false;
          await modalVideo.play();
        } catch (e) {}
      };

      const stopModalVideo = () => {
        try {
          modalVideo.pause();
          modalVideo.currentTime = 0;
        } catch (e) {}
      };

      trigger.addEventListener('click', () => {
        try {
          if (previewVideo) previewVideo.pause();
        } catch (e) {}

        stopModalVideo();
        playModalVideo();
      });

      root.addEventListener('dialog:close', () => {
        stopModalVideo();
        try {
          if (previewVideo) previewVideo.play();
        } catch (e) {}
      });

      dialog.addEventListener('close', () => {
        stopModalVideo();
        try {
          if (previewVideo) previewVideo.play();
        } catch (e) {}
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spx-video-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('dialog-component[data-spx-video-dialog]');

    roots.forEach((root) => {
      const trigger = root.querySelector('button.spx-video-dialog__trigger');
      const dialog = root.querySelector('dialog.spx-video-dialog__dialog');
      const previewVideo = root.querySelector('video.spx-video-dialog__preview-video');
      const modalVideo = root.querySelector('video.spx-video-dialog__video');

      if (!trigger || !dialog || !modalVideo) return;

      const playPreviewVideo = async () => {
        if (!previewVideo) return;

        try {
          previewVideo.muted = true;
          await previewVideo.play();
        } catch (e) {}
      };

      const playModalVideo = async () => {
        try {
          modalVideo.muted = false;
          await modalVideo.play();
        } catch (e) {}
      };

      const stopModalVideo = () => {
        try {
          modalVideo.pause();
          modalVideo.currentTime = 0;
        } catch (e) {}
      };

      // 尝试在组件初始化时立即播放预览视频
      playPreviewVideo();

      trigger.addEventListener('click', () => {
        try {
          if (previewVideo) previewVideo.pause();
        } catch (e) {}

        stopModalVideo();
        playModalVideo();
      });

      root.addEventListener('dialog:close', () => {
        stopModalVideo();
        try {
          if (previewVideo) previewVideo.play();
        } catch (e) {}
      });

      dialog.addEventListener('close', () => {
        stopModalVideo();
        try {
          if (previewVideo) previewVideo.play();
        } catch (e) {}
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spx-video-or-image"] && !Shopify.designMode) return;
  try {
    (() => {
    const rootSelector = '[data-spx-video-manual]';
    const state = window.__spxVideoManualState || {
      cleanups: new WeakMap(),
      domReadyBound: false,
      observer: null,
      sectionLoadBound: false,
    };
    window.__spxVideoManualState = state;

    const emitVideoEvent = (root, type, video) => {
      root.dispatchEvent(
        new CustomEvent(`spx:video:${type}`, {
          bubbles: true,
          detail: { root, video },
        }),
      );
    };

    const resetManualVideo = (root, video) => {
      try {
        video.pause();
        video.currentTime = 0;
      } catch (e) {}

      root.removeAttribute('data-playing');
      emitVideoEvent(root, 'reset', video);
    };

    const resetOtherManualVideos = (currentRoot) => {
      const otherRoots = document.querySelectorAll(rootSelector);
      otherRoots.forEach((otherRoot) => {
        if (!(otherRoot instanceof HTMLElement)) return;
        if (otherRoot === currentRoot) return;
        if (otherRoot.dataset.spxVideoAutoplay === 'true') return;

        const otherVideo = otherRoot.querySelector('video');
        if (!(otherVideo instanceof HTMLVideoElement)) return;

        resetManualVideo(otherRoot, otherVideo);
      });
    };

    const initManualVideo = (root) => {
      if (!(root instanceof HTMLElement)) return;
      if (root.dataset.spxVideoManualInit === 'true') return;

      const video = root.querySelector('video');
      const playBtn = root.querySelector('button.spx-video-manual__play');
      const pauseBtn = root.querySelector('button.spx-video-manual__btn--pause');
      const soundBtn = root.querySelector('button.spx-video-manual__btn--sound');
      if (!(video instanceof HTMLVideoElement) || !(playBtn instanceof HTMLButtonElement)) return;

      const controller = new AbortController();
      const audible = root.dataset.spxVideoAudible === 'true';
      const centerToggle = root.dataset.spxVideoCenterToggle === 'true';
      root.dataset.spxVideoManualInit = 'true';

      const syncMutedState = () => {
        const isMuted = Boolean(video.muted);
        root.setAttribute('data-muted', isMuted ? 'true' : 'false');
        if (soundBtn instanceof HTMLButtonElement) {
          soundBtn.setAttribute('aria-pressed', isMuted ? 'true' : 'false');
          soundBtn.setAttribute('aria-label', isMuted ? 'Unmute' : 'Mute');
        }
      };
      syncMutedState();

      const handlePlay = () => {
        root.setAttribute('data-playing', 'true');
        playBtn.setAttribute('aria-label', 'Pause video');
        emitVideoEvent(root, 'play', video);
      };
      const handlePause = () => {
        root.removeAttribute('data-playing');
        playBtn.setAttribute('aria-label', 'Play video');
        emitVideoEvent(root, 'pause', video);
      };
      const handleEnded = () => {
        root.removeAttribute('data-playing');
        playBtn.setAttribute('aria-label', 'Replay video');
        emitVideoEvent(root, 'ended', video);
      };
      const playFromGesture = async () => {
        try {
          resetOtherManualVideos(root);

          if (video.ended || (Number.isFinite(video.duration) && video.currentTime >= video.duration)) {
            video.currentTime = 0;
            emitVideoEvent(root, 'reset', video);
          }

          if (audible) video.muted = false;
          syncMutedState();
          await video.play();
        } catch (e) {}
      };
      const togglePlayback = () => {
        if (centerToggle && !video.paused) {
          video.pause();
          return;
        }

        if (video.paused) playFromGesture();
      };

      video.addEventListener('play', handlePlay, { signal: controller.signal });
      video.addEventListener('pause', handlePause, { signal: controller.signal });
      video.addEventListener('ended', handleEnded, { signal: controller.signal });
      playBtn.addEventListener('click', togglePlayback, { signal: controller.signal });

      if (pauseBtn instanceof HTMLButtonElement) {
        pauseBtn.addEventListener('click', () => video.pause(), { signal: controller.signal });
      }

      if (soundBtn instanceof HTMLButtonElement) {
        soundBtn.addEventListener(
          'click',
          () => {
            video.muted = !video.muted;
            syncMutedState();
          },
          { signal: controller.signal },
        );
      }

      if (!video.paused) {
        root.setAttribute('data-playing', 'true');
        playBtn.setAttribute('aria-label', 'Pause video');
      }

      state.cleanups.set(root, () => {
        controller.abort();
        resetManualVideo(root, video);
        delete root.dataset.spxVideoManualInit;
        state.cleanups.delete(root);
      });
    };

    function initSpXVideoManual(root = document) {
      if (root instanceof HTMLElement && root.matches(rootSelector)) initManualVideo(root);
      if (!root || typeof root.querySelectorAll !== 'function') return;

      root.querySelectorAll(rootSelector).forEach((manualRoot) => initManualVideo(manualRoot));
    }

    window.initSpXVideoManual = initSpXVideoManual;

    if (document.readyState === 'loading') {
      if (!state.domReadyBound) {
        state.domReadyBound = true;
        document.addEventListener('DOMContentLoaded', () => initSpXVideoManual(), { once: true });
      }
    } else {
      initSpXVideoManual();
    }

    if (!state.sectionLoadBound) {
      state.sectionLoadBound = true;
      document.addEventListener('shopify:section:load', (event) => initSpXVideoManual(event.target));
    }

    if (!state.observer && document.documentElement) {
      state.observer = new MutationObserver((records) => {
        records.forEach((record) => {
          record.removedNodes.forEach((node) => {
            if (!(node instanceof HTMLElement)) return;

            const removedRoots = node.matches(rootSelector)
              ? [node, ...node.querySelectorAll(rootSelector)]
              : node.querySelectorAll(rootSelector);
            removedRoots.forEach((removedRoot) => {
              if (removedRoot.isConnected) return;
              const cleanup = state.cleanups.get(removedRoot);
              if (cleanup) cleanup();
            });
          });

          record.addedNodes.forEach((node) => {
            if (node instanceof HTMLElement) initSpXVideoManual(node);
          });
        });
      });
      state.observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
